import {
    getVueInstance as vue,
} from '@shared/utils/instance';

export type ValidationResult = boolean | string;
export type Validation = (value: string) => ValidationResult;

export const runValidations = (validations: Validation[], value: string) => {
    const results = validations.map((validation: Validation) => validation(value));

    return results.find((result: ValidationResult) => typeof result === 'string');
};

// Dates
export const validDateOfBirth: Validation = (date: string) => (new Date(date) >= new Date('1900-01-01')) ||
    vue().$t('errors.invalidBirthDate');

export const isDateOfBirthOlderThan18: Validation = (date: string) => {
    const date18yearsAgo = new Date();

    date18yearsAgo.setFullYear(date18yearsAgo.getFullYear() - 18);
    date18yearsAgo.setHours(24, 0, 0, 0);

    return new Date(date) <= date18yearsAgo || vue().$t('errors.birthDateUnder18');
};

export const dateGreaterThanToday: Validation = (date: string) => (new Date(date) >= new Date()) ||
    vue().$t('errors.dateHasToBeGreaterThanToday');